import { render, staticRenderFns } from "./Socialfooter.vue?vue&type=template&id=ff80a840&"
import script from "./Socialfooter.vue?vue&type=script&lang=js&"
export * from "./Socialfooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports